export default {
    enableInput(emit) {
        if (!emit && this.prop('disabled') === false)
            return this;

        this.prop('disabled', false);
        this.trigger('change', ['disabled', false]);
        return this;
    },
    disableInput(emit) {
        if (!emit && this.prop('disabled') === true)
            return this;

        this.prop('disabled', true);
        this.trigger('change', ['disabled', true]);
        return this;
    },
    check(emit) {
        if (!emit && this.prop('checked') === true)
            return this;

        this.prop('checked', true);
        this.trigger('change', ['checked', true]);
        return this;
    },
    uncheck(emit) {
        if (!emit && this.prop('checked') === false)
            return this;

        this.prop('checked', false);
        this.trigger('change', ['checked', false]);
        return this;
    }
};